
export const NavData = [

    {
        title: 'About',
        path: '/',
        cName: 'nav-text'
    },
    {
        title: 'Portfolio',
        path: '/portfolio-page',
        cName: 'nav-text'
    },
    {
        title: 'Contact',
        path: '/contact-page',
        cName: 'nav-text'
    },
]